import { ArrowLeft, Menu } from "lucide-react";
import { Link } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { CopilotoQuickBox } from "@/features/copiloto/CopilotoQuickBox";
import { MestraIcon } from "@/features/copiloto/MestraIcon";
import { CompanySwitcher } from "@/shell/CompanySwitcher";
import { NotificationBell } from "@/shell/NotificationBell";
import type { CompanyContext } from "@/shared/api/api-client";
import { OPEN_MESTRA_EVENT } from "@/shared/keyboard/shortcuts";

export function Topbar({
  title,
  back,
  token,
  company,
  onMenu,
  copiloto = true
}: {
  title: string;
  /** A tela-mãe, quando a tela é um nível abaixo de uma seção (ver
   *  `backTargetForPath`). Sem ela, não há botão de voltar. */
  back?: { href: string; label: string } | null;
  token: string;
  company: CompanyContext | null;
  onMenu?: () => void;
  /** A Mestra Help gasta IA: o Visualizador (2026-10-22) não a vê, e o
   *  servidor também a recusa pra ele. */
  copiloto?: boolean;
}) {
  const [showCopiloto, setShowCopiloto] = useState(false);
  // G M (atalho de teclado) abre a Mestra Help daqui do canto.
  useEffect(() => {
    if (!copiloto) return;
    const open = () => setShowCopiloto(true);
    window.addEventListener(OPEN_MESTRA_EVENT, open);
    return () => window.removeEventListener(OPEN_MESTRA_EVENT, open);
  }, [copiloto]);
  const copilotoButtonRef = useRef<HTMLButtonElement>(null);

  return (
    <header className="topbar">
      {onMenu && (
        <button className="icon-button mobile-menu" onClick={onMenu} aria-label="Abrir menu">
          <Menu size={19}/>
        </button>
      )}
      {back && (
        <Link className="icon-button topbar-back" to={back.href} aria-label={`Voltar para ${back.label}`} title={`Voltar para ${back.label}`}>
          <ArrowLeft size={17}/>
        </Link>
      )}
      <h1 className="topbar-title">{title}</h1>
      <div className="top-actions">
        {company && <CompanySwitcher company={company}/>}
        <NotificationBell token={token}/>
        {copiloto && <button
          ref={copilotoButtonRef}
          className="icon-button mestra-help-shortcut"
          onClick={() => setShowCopiloto(value => !value)}
          aria-label="Mestra Help"
          title="Mestra Help"
          aria-haspopup="dialog"
          aria-expanded={showCopiloto}
        >
          <MestraIcon size={15}/>
        </button>}
        {copiloto && showCopiloto && (
          <CopilotoQuickBox
            token={token}
            anchorRef={copilotoButtonRef}
            onClose={() => setShowCopiloto(false)}
          />
        )}
      </div>
    </header>
  );
}
